import { useRef } from "react";
import { useReactToPrint } from "react-to-print";
import { Modal, ModalBody } from "reactstrap";
import { Btn, H3 } from "../../../AbstractElements";
import { Cancel, Print, PrintViews } from "../../../Constant";
import { PrintModalPropsTypes } from "../../../Type/ContactType";
import PrintPreview from "./PrintPreview";

const PrintModal = ({ printModal, selectedUser, toggleCallback }: PrintModalPropsTypes) => {
  const printModalToggle = () => {
    toggleCallback(false);
  };

  const contentRef = useRef<HTMLDivElement | null>(null);

  const handlePrint = useReactToPrint({
    contentRef,
  });

  return (
    <Modal fade className="modal-bookmark" isOpen={printModal} toggle={printModalToggle}>
      <div className="modal-header">
        <H3 className="modal-title">{PrintViews}</H3>
        <Btn color="transprant" className="btn-close" onClick={printModalToggle} type="button"></Btn>
      </div>
      <ModalBody className="list-persons">
        <PrintPreview selectedUser={selectedUser} />
        <Btn color="secondary" className="me-1" onClick={handlePrint}>
          {Print}
        </Btn>

        <Btn color="primary" onClick={printModalToggle}>
          {Cancel}
        </Btn>
      </ModalBody>
    </Modal>
  );
};

export default PrintModal;
